export const navigation = [
    {
        text: 'Dashboard',
        path: '/dashboard',
        icon: 'dashboard'
    },
    {
        text: 'AI Pathta Assistant',
        path: '/assistant',
        icon: 'assistant'
    },
    {
        text: 'Paths',
        path: '/paths',
        icon: 'paths'
    },
    {
        text: 'Runs',
        path: '/runs',
        icon: 'runs'
    },
    {
        text: 'Reporting',
        path: '/reporting-groups',
        icon: 'paths'
    },
    {
        text: 'Meta APIs',
        path: '/metaapis',
        icon: 'metaapis'
    },
    {
        text: 'AI Client Assistant',
        path: '/ai-groups',
        icon: 'assistant'
    },
    {
        text: 'Portal',
        path: '/portal',
        icon: 'portal'
    },
    {
        text: 'Settings',
        path: '/global-settings',
        icon: 'settings',
        enterpriseOnly: false
    },
    {
        text: 'Settings',
        icon: 'settings',
        enterpriseOnly: true,
        items: [
            {
                text: 'Global',
                path: '/global-settings'
            },
            {
                text: 'Workspace',
                path: '/workspace-settings'
            }
        ]
    },
    {
        text: 'Billing',
        path: '/billing',
        icon: 'billing'
    },
    //{
    //    text: 'Explore',
    //    path: '/explore',
    //    icon: 'explore'
    //},
    {
        text: 'Help',
        path: '/help',
        icon: 'help'
    }
];
